/**
 * HeroBanner - homepage/landing hero banner block.
 * Custom element: <hero-banner>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class HeroBanner extends ThemeComponent {}
setFunctionName(HeroBanner, "HeroBanner");
const propertyTypes = {};
HeroBanner.prototype.$name = "HeroBanner";
HeroBanner.prototype.$info = JSON.parse('{"name":"HeroBanner","meta":{"isLegacy":false,"selector":"hero-banner"},"props":[],"refs":[]}');
HeroBanner.prototype.$info.component = HeroBanner;
for (const prop of HeroBanner.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("HeroBanner/HeroBanner.ts", {
  HeroBanner: HeroBanner
}, void 0);